import { useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';

import useScreenSize from '@/hooks/useScreenSize';
import SuarteName from '@/shared-components/icons/components/public/SuarteName';

import AppNavigationOptions from './AppNavigationOptions';

import './styles/AppNavigation.css';

export default function AppNavigation() {
  const screenSize = useScreenSize();

  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname);

  const handleLinkClick = (path) => {
    setActiveLink(path);
  };

  return (
    <>
      <div className="app-navigation__page">
        <nav className="app-navigation__container-outter">
          <div className="app-navigation__container">
            {screenSize.width > 650 && <Link className="app-navigation__suarte-name-link" to="/" aria-label="Home" onClick={() => handleLinkClick("/")}>
              <SuarteName/>
            </Link>}
            <AppNavigationOptions activeLink={activeLink}  handleLinkClick={handleLinkClick}/>
          </div>
        </nav>

        <Outlet/>
      </div>
    </>
  );
}
